<template>
  <v-dialog persistent width="90%" v-model="disciplinaAdministrativaDialog">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="secondary" class="mx-2" v-on="on" v-bind="attrs">Disciplina Administrativa</v-btn>
    </template>
    <v-card color="primary" class="rounded-sm">
      <v-card-title>
        <div class="text-h6">Evaluación de disciplina administrativa</div>
        <v-spacer></v-spacer>
        <v-btn icon color="error" @click="closeDialog()"><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text v-if="disciplinaAdministrativa">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-card elevation="4" class="rounded-sm">
                <v-card-title>
                  <div class="text-subtitle-1 font-weight-bold">Información general</div>
                </v-card-title>
                <v-card-text>
                  <InformacionGeneralEvaluacionSection :evaluacion="disciplinaAdministrativa" />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <TiposIncidenciaForm :incidencias="disciplinaAdministrativa.incidencias" />
            </v-col>
            <v-col>
              <ActasAdministrativasForm :actas-administrativas="disciplinaAdministrativa.actasAdministrativas" />
            </v-col>
            <v-col>
              <EstimulosForm :estimulos="disciplinaAdministrativa.estimulos" />
            </v-col>
            <v-col>
              <ReconocimientosForm :reconocimientos="disciplinaAdministrativa.reconocimientos" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <TextButton
          color="secondary"
          @click="triggerSaveDisciplinaAdministrativa()"
          :loading="loading"
          v-if="!isPerfilPolicia"
        >
          Guardar evaluación
        </TextButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import UpdateEvaluacionDisciplinaAdministrativaUseCase from '@/modules/evaluacion-desempeño/application/usecases/UpdateEvaluacionDisciplinaAdministrativa.usecase'
import { mapActions } from 'vuex'
import EvaluacionDisciplinaAdministrativaApiRepository from '@/modules/evaluacion-desempeño/infrastructure/EvaluacionDisciplinaAdministrativaApi.repository'
import TiposIncidenciaForm from './evaluacion-desempeño/disciplina-administrativa/forms/TiposIncidenciaForm.vue'
import ActasAdministrativasForm from './evaluacion-desempeño/disciplina-administrativa/forms/ActasAdministrativasForm.vue'
import EstimulosForm from './evaluacion-desempeño/disciplina-administrativa/forms/EstimulosForm.vue'
import ReconocimientosForm from './evaluacion-desempeño/disciplina-administrativa/forms/ReconocimientosForm.vue'
import InformacionGeneralEvaluacionSection from './evaluacion-desempeño/common/InformacionGeneralEvaluacionSection.vue'
import { PERFILES } from '@/perfiles.js'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: {
    TiposIncidenciaForm,
    ActasAdministrativasForm,
    EstimulosForm,
    ReconocimientosForm,
    InformacionGeneralEvaluacionSection,
    TextButton,
  },

  props: {
    disciplinaAdministrativa: {
      type: Object,
    },
  },

  data() {
    return {
      disciplinaAdministrativaDialog: false,
      loading: false,
    }
  },

  computed: {
    isPerfilPolicia() {
      const perfilLocal = localStorage.getItem('perfil')?.toLowerCase().trim()
      const perfilConst = PERFILES.Policia?.toLowerCase().trim()
      return perfilLocal === perfilConst
    },
  },
  methods: {
    ...mapActions('disciplinaAdministrativa', ['updateDisciplinaAdministrativa']),

    closeDialog() {
      this.loading = false
      this.disciplinaAdministrativaDialog = false
    },

    async triggerSaveDisciplinaAdministrativa() {
      this.loading = true

      new UpdateEvaluacionDisciplinaAdministrativaUseCase(
        new EvaluacionDisciplinaAdministrativaApiRepository()
      ).execute(this.disciplinaAdministrativa)

      this.closeDialog()
    },
  },
}
</script>

<style scoped>
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep input,
::v-deep textarea {
  color: #e0e0e0 !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-divider {
  border-color: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}
</style>
